<!--
    描述：签署配置信息
    日期：2022/06/27
    作者：张卫华
-->
<template>
  <div class="tab-main-page">
    <div class="main-content">
      <el-row>
        <el-col :span="12">
          <span style="font-weight: bold">签署配置信息：</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署完成，重定向跳转地址：htttps://523.eqb.comcxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署平台：1-H5网页版方式进行签署；2-跳转支付宝(移动端)或支付宝扫码进行签署(PC端)。
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署也是否显示图片章：显示 - true;关闭显示 - false
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            签署页面提交倒计时：20秒
          </span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <span class="ml20">
            是否使用e签盾签署：1-不使用e签盾；2-使用e签盾
          </span>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name : 'detail_tab_sci',
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {},
  computed: {},
  // 进入缓存页面
  activated() {

  },
  watch: {},
  created() {},
  methods: {

  }
}
</script>
<style lang="less" scoped>
.tab-main-page {
  .main-content {
    font-family: 'Arial Normal', 'Arial';
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    color: #333333;
    line-height: normal;

    .el-row {
      padding : 10px 0px;
    }
  }
}
</style>